<template>
  <div class="row">
    <!--  角色列表  -->
    <div class="flex xs12">
      <va-card title="角色">
        <div class="row align-center mb-1">
          <div class="flex md6 xs12">
            <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
          <div class="flex md6 xs12 sm12">
            <div class="d-flex justify--end">
              <va-button color="info" small :to="{ name: 'saveRole' }">新增角色</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="roles"
          :loading="loading"
          api-mode
        >
          <template slot="actions" slot-scope="props">
            <va-button flat small color="gray" icon="fa fa-eye"
              :to='{path:`updateRole/${props.rowData.id}`}'/>
            <va-button flat small color="gray" icon="fa fa-trash"
              @click="deleteModal = true;deleteId=props.rowData.id"/>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="删除角色"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>
import roleApi from '../../api/role'
import { formatTime } from '@/utils/common'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      roles: [],
      totalCount: 0,
      loading: true,
      deleteModal: false,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'displayName',
          title: '角色名称',
          width: '18%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'level',
          title: '角色等级',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'name',
          title: '角色代码',
          width: '18%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'description',
          title: '描述',
          width: '18%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '18%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listRole()
  },
  methods: {
    listRole () {
      this.loading = true
      roleApi.listRoles().then(response => {
        this.roles = response.roles
        this.roles.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.loading = false
        this.totalCount = response.totalCount
      }).catch(error => alert(error))
    },
    confirmDelete () {
      if (this.deleteId === null) return
      roleApi.deleteRole(this.deleteId).then(response => {
        if (response.success === true) {
          this.showToast('删除角色成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listRole()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
